<template>
  <div class="qcc-supplier-search-container">
    <div style="border-radius: 30px">
      <el-form :inline="true" size="mini" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-row>
          <el-form-item label="供应商账号" prop="venderLogin">
            <el-input size="mini" v-model="venderLogin" style="width: 150px" placeholder="供应商账号" clearable @blur="getDataList"></el-input>
          </el-form-item>
          <el-form-item label="供应商代码" prop="venderCode">
            <el-input size="mini" v-model="venderCode" style="width: 150px" placeholder="供应商代码" clearable @blur="getDataList"></el-input>
          </el-form-item>
          <el-form-item label="供应商名称" prop="venderName">
            <el-input size="mini" v-model="venderName" style="width: 150px" placeholder="供应商名称" clearable @blur="getDataList"></el-input>
          </el-form-item>


          <el-button size="mini" @click="queryHandle()" icon="el-icon-search" style="margin-left:20px">查询</el-button>
        </el-row>
      </el-form>
    </div>

    <div v-loading="dataListLoading">
      <el-table :data="dataList" size="mini" :row-class-name="rowClassName"
                :height="tableHeight" border :header-cell-style="{background:'#f5f5f5'}">
        <el-table-column header-align="center" label="序号" align="center" width="55">
          <template slot-scope="scope">
            {{ scope.row.rowid }}
          </template>
        </el-table-column>

        <el-table-column prop="venderLogin" header-align="center" align="left" label="供应商账号" min-width="130">
          <template slot-scope="scope">
            {{ scope.row.venderLogin }}
          </template>
        </el-table-column>

        <el-table-column prop="venderCode" header-align="center" align="left" label="供应商代码" min-width="130">
          <template slot-scope="scope">
            {{ scope.row.venderCode }}
          </template>
        </el-table-column>

        <el-table-column prop="venderName" header-align="center" align="left" label="供应商名称" min-width="200">
          <template slot-scope="scope">
            {{ scope.row.venderName }}
          </template>
        </el-table-column>


        <el-table-column fixed="right" header-align="center" align="center" label="操作" min-width="140px">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="queryQccCompany(scope.row)" icon="el-icon-search">
              企查查查询
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>

    <!-- 企查查查询弹窗 -->
    <el-dialog title="企查查企业查询" :visible.sync="qccDialogVisible" width="90%" append-to-body>
      <div style="height: 80vh;">
        <iframe id="qccIframe" ref="qccIframe" frameborder="0" style="width: 100%; height: 100%;" allowfullscreen></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {selectQccSupplier} from '@/controller/supplier'
import {getToken} from '@/controller/supplier'

export default {
  name: 'QccSupplierSearch',
  data() {
    return {
      dataForm: {
        key: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      venderName: '',
      venderCode: '',
      supplierLevel: '',
      options2: [
        {
          supplierLevel: '0',
          label: '潜在'
        },
        {
          supplierLevel: '1',
          label: '合格'
        }
      ],
      qccDialogVisible: false,
      currentSupplier: null
    }
  },
  computed: {
    tableHeight: {
      get() {
        return this.$store.state.common.documentClientHeight - 260
      }
    }
  },
  mounted() {
    this.getDataList()
  },
  methods: {
    // 查询按钮
    queryHandle() {
      this.pageIndex = 1
      this.getDataList()
    },

    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      selectQccSupplier({
        'pageNo': this.pageIndex,
        'pageSize': this.pageSize,
        'venderCode': this.venderCode,
        'venderName': this.venderName,
        'venderLogin': this.venderLogin
      }).then(data => {
        if (data && data.code === '00') {
          this.dataList = data.body.records
          this.totalPage = data.body.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
      }).catch((e) => {
        console.log(e)
      }).finally(() => {
        this.dataListLoading = false
      })
    },

    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },

    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },

    rowClassName({row, rowIndex}) {
      //把每一行的索引放进row.id
      row.rowid = rowIndex + 1 + (this.pageSize * (this.pageIndex - 1));
    },

    // 企查查查询
    async queryQccCompany(row) {
      try {
        this.currentSupplier = row;
        this.qccDialogVisible = true;

        // 等待弹窗渲染完成后再加载iframe内容
        this.$nextTick(async () => {
          await this.loadQccPage();
        });
      } catch (error) {
        console.error('企查查查询失败:', error);
        this.$message.error('企查查查询失败');
      }
    },

    // 加载企查查页面
    async loadQccPage() {
      try {
        // 调用后端API获取token
        const tokenResponse = await getToken({});
        if (tokenResponse && tokenResponse.code === '00') {
          const token = encodeURIComponent(tokenResponse.body.token);

          // 企查查提供的key（需要替换为实际的key）
          const qccKey = '60585352000c11f1b1c0b8cef6b42328';

          // 构建查询关键字
          const searchKey = this.currentSupplier.venderName || '测试';

          // returnUrl编码
          const returnUrl = encodeURIComponent(`/search?searchkey=${searchKey}`);

          // 构建企查查URL
          const qccUrl = `https://pro-plugin.qcc.com/plugin-login?key=${qccKey}&token=${token}&returnUrl=${returnUrl}`;

          const iframe = this.$refs.qccIframe;
          if (iframe) {
            iframe.src = qccUrl;
          }
        } else {
          this.$message.error('获取企查查token失败');
        }
      } catch (error) {
        console.error('加载企查查页面失败:', error);
        this.$message.error('加载企查查页面失败');
      }
    }
  }
}
</script>

<style lang="scss">
.qcc-supplier-search-container {
  padding: 20px;
}

.el-table .el-button + .el-button {
  margin-left: 0;
}
</style>
